import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { If, Then, Else } from 'react-if';
import './Category.css';
import { ReactComponent as FilterIcon } from './filter-icon.svg';
import { ReactComponent as SelectedIcon } from './selected-icon.svg';
import classNames from 'classnames';
import { useSelector } from '../../../hooks/useSelector';

const Category = ({ isDisabled, category, categoryToggle }) => {
    const { activeCategory } = useSelector(state => state.categories);

    const isActive = useMemo(() => {
        return activeCategory && activeCategory.includes(category.uid);
    }, [activeCategory, category]);

    const style = useMemo(() => {
        return isActive
            ? {
                  backgroundColor: category.color,
                  color: '#fff',
              }
            : {
                  backgroundColor: '#F4F4F4',
                  color: '#020810',
              };
    }, [isActive, category.color]);

    const baseCategoryClass = useMemo(() => {
        return classNames({
            category: true,
            [category.uid]: true,
            'disabled-category': isDisabled,
        });
    }, [category.uid, isDisabled]);

    const handleCategoryClick = useCallback(() => {
        return !isDisabled ? categoryToggle(category) : null;
    }, [categoryToggle, category]);

    return (
        <div style={style} className={baseCategoryClass} onClick={handleCategoryClick}>
            {isActive && (
                <div className="selected-icon-wrap">
                    <SelectedIcon />
                </div>
            )}
            <span className="category-button-text w-100">{category.label}</span>
        </div>
    );
};

Category.propTypes = {
    category: PropTypes.object.isRequired,
    categoryToggle: PropTypes.func.isRequired,
};

Category.defaultProps = {};

export default React.memo(Category);
